/**
 * The read-only value pattern (FRM-015, DS-001/002): a `dl` of label / value pairs in two
 * columns. Read-only values look different from inputs and stay selectable. Shared by the
 * Agreement screen and the rate card page (TMMRSL-0041).
 */
import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export function DefinitionList({ children }: { children: ReactNode }) {
  return (
    <Box
      component="dl"
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        columnGap: 2,
        rowGap: 1,
        m: 0,
      }}
    >
      {children}
    </Box>
  );
}

export function DefinitionField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <>
      <Typography component="dt" variant="body2" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography component="dd" variant="body2" sx={{ m: 0 }}>
        {children}
      </Typography>
    </>
  );
}
